import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid-pro";
import Export from "./Export";
import PreTransactionFilter from "./PreTransactionFilter";

const CustomToolbar = (props) => {
  const { 
    onPreTransactionFilterChange,
    excludePreTransactionsDefault = null,
    showPreTransactionFilter = false,
    tooltipText,
    ...otherProps 
  } = props;

  return (
    <GridToolbarContainer {...otherProps}>
      <GridToolbarColumnsButton />
      <Export {...otherProps} />
      {showPreTransactionFilter && ( 
          <PreTransactionFilter 
            onChange={onPreTransactionFilterChange}
            defaultChecked={excludePreTransactionsDefault}
            tooltipText={tooltipText}
          />
      )} 
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
